export default "__VITE_ASSET__cfvh281p__"